import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  button: {
    display: 'flex',
    color: '#159B78',
    fontSize: '18px'
  },
  clearFitlerPurchaseButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: 600,
    fontSize: '12px',
    border: 'none',
    borderRadius: '5px',
    padding: 0,
    transition: 'color 0.25s linear, background-color 0.25s linear',
    color: '#0a775a',
    backgroundColor: 'inherit',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8
    },
    '&:disabled': {
      cursor: 'not-allowed',
      color: '#a4a4a4'
    }
  },
  iconClearPurchase: {
    transition: 'color 0.25s linear',
    fontSize: '20px'
  }
}));
